import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-99091378"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"display":"inline-flex"} }, "主单信息", -1))
const _hoisted_2 = { class: "form-table" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "form-table-td-count" }, [
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "录入【Master Bill No.】和对应的【承运人】，点击按钮可获取相应信息（标题绿色）", -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  colspan: "10",
  class: "containers"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "箱号", -1))
const _hoisted_8 = { colspan: "10" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "附件", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_miezz_button = _resolveComponent("miezz-button")!
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_order_form_company_business_card = _resolveComponent("order-form-company-business-card")!
  const _component_order_form_products_summary = _resolveComponent("order-form-products-summary")!
  const _component_order_form_container = _resolveComponent("order-form-container")!
  const _component_order_form_lading_bill = _resolveComponent("order-form-lading-bill")!
  const _component_miezz_upload = _resolveComponent("miezz-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_miezz_card = _resolveComponent("miezz-card")!
  const _component_company_business_card_form = _resolveComponent("company-business-card-form")!
  const _component_miezz_modal = _resolveComponent("miezz-modal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createBlock(_component_miezz_card, {
      fix: true,
      "bottom-buttons": _ctx.buttons,
      onHandleFooterButtonClick: _ctx.handleClick
    }, {
      headerLeft: _withCtx(() => [
        _hoisted_1,
        (_ctx.form.Data)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              style: {"display":"inline-flex","margin":"0px"},
              label: "业务所属周期",
              prop: "BusinessCycle",
              rules: _ctx.form.Rules.BusinessCycle,
              "label-width": "141px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.form.Data.BusinessCycle,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.Data.BusinessCycle) = $event)),
                  type: "month",
                  class: "form-item-date",
                  clearable: false,
                  disabled: _ctx.detail?.BusinessDate != undefined
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["rules"]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        (_ctx.form.Data)
          ? (_openBlock(), _createBlock(_component_el_form, {
              key: 0,
              model: _ctx.form.Data,
              ref: "ruleForm",
              rules: _ctx.form.Rules,
              "label-width": "200px"
            }, {
              default: _withCtx(() => [
                _createElementVNode("table", _hoisted_2, [
                  _hoisted_3,
                  _createVNode(_component_order_form_company_business_card, {
                    form: _ctx.form,
                    "onUpdate:form": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.form) = $event)),
                    scene: "MainBill",
                    red: _ctx.addDeparturePortBookingMainBill && _ctx.detail?.DeparturePortBooking
                  }, {
                    default: _withCtx(() => [
                      (_ctx.detail?.UseThreeApiService)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            style: {"color":"red","margin-bottom":"0px"}
                          }, {
                            label: _withCtx(() => [
                              _createVNode(_component_miezz_button, {
                                style: {"margin-top":"5px"},
                                model: _ctx.btnAutoPullThreeApiData,
                                onHandleClick: _ctx.autoPullThreeApiData
                              }, null, 8, ["model", "onHandleClick"])
                            ]),
                            default: _withCtx(() => [
                              _hoisted_4
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_form_item, {
                        label: "Master Bill No.",
                        prop: "MasterBillNo"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_input, {
                            modelValue: _ctx.form.Data.MasterBillNo,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.Data.MasterBillNo) = $event)),
                            pattern: "[0-9a-z-]",
                            upperCase: true,
                            trimAll: true,
                            red: 
                  _ctx.addDeparturePortBookingMainBill &&
                  (_ctx.detail?.DeparturePortBooking ||
                    (!_ctx.detail?.DeparturePortBooking &&
                      (_ctx.detail?.DeparturePortDeclareCustoms ||
                        _ctx.detail?.DestinationPortClearCustoms)))
                ,
                            onHandleBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleBillNoBlur('MasterBillNo')))
                          }, null, 8, ["modelValue", "red"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "House Bill No.",
                        prop: "HouseBillNo"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_input, {
                            modelValue: _ctx.form.Data.HouseBillNo,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.Data.HouseBillNo) = $event)),
                            pattern: "[0-9a-z-]",
                            upperCase: true,
                            trimAll: true,
                            placeholder: "如订舱代理签发的为House Bill，请在此填写提单号码",
                            onHandleBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleBillNoBlur('HouseBillNo')))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        prop: "LoadingPortId",
                        label: "Port of Loading/装货港",
                        class: _normalizeClass(_ctx.detail?.UseThreeApiService ? 'query' : '')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_select, {
                            modelValue: _ctx.form.Data.LoadingPortId,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.Data.LoadingPortId) = $event)),
                            label: _ctx.form.Data.LoadingPortLabel,
                            "onUpdate:label": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.Data.LoadingPortLabel) = $event)),
                            options: _ctx.loadingPorts,
                            remote: true,
                            remoteMethod: _ctx.getLoadingPorts,
                            placeholder: '请填写关键词',
                            noDataText: '无匹配数据，请至参数管理中添加',
                            red: 
                  _ctx.addDeparturePortBookingMainBill &&
                  (_ctx.detail?.DeparturePortBooking ||
                    (!_ctx.detail?.DeparturePortBooking &&
                      (_ctx.detail?.DeparturePortDeclareCustoms ||
                        _ctx.detail?.DestinationPortClearCustoms)))
                ,
                            onHandleChange: _cache[7] || (_cache[7] = ($event: any) => (
                  _ctx.handleChangePort(
                    _ctx.form.Data.LoadingPortId,
                    _ctx.detail?.LoadingPortId
                  )
                )),
                            disabled: 
                  _ctx.form.Data?.BindThreeApiPropList?.contains('LoadingPortId')
                
                          }, null, 8, ["modelValue", "label", "options", "remoteMethod", "red", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["class"]),
                      _createVNode(_component_el_form_item, {
                        label: "Port of Discharge/卸货港",
                        prop: "DischargePortId",
                        class: _normalizeClass(_ctx.detail?.UseThreeApiService ? 'query' : '')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_select, {
                            modelValue: _ctx.form.Data.DischargePortId,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.Data.DischargePortId) = $event)),
                            label: _ctx.form.Data.DischargePortLabel,
                            "onUpdate:label": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.Data.DischargePortLabel) = $event)),
                            options: _ctx.dischargePorts,
                            remote: true,
                            remoteMethod: _ctx.getDischargePorts,
                            placeholder: '请填写关键词',
                            noDataText: '无匹配数据，请至参数管理中添加',
                            disabled: 
                  _ctx.form.Data?.BindThreeApiPropList?.contains('DischargePortId')
                
                          }, null, 8, ["modelValue", "label", "options", "remoteMethod", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["class"]),
                      _createVNode(_component_el_form_item, {
                        label: "Port of Delivery/目的港",
                        prop: "DeliveryPortId",
                        class: _normalizeClass(_ctx.detail?.UseThreeApiService ? 'query' : '')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_select, {
                            modelValue: _ctx.form.Data.DeliveryPortId,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.Data.DeliveryPortId) = $event)),
                            label: _ctx.form.Data.DeliveryPortLabel,
                            "onUpdate:label": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.Data.DeliveryPortLabel) = $event)),
                            options: _ctx.deliveryPorts,
                            remote: true,
                            remoteMethod: _ctx.getDeliveryPorts,
                            placeholder: '请填写关键词',
                            noDataText: '无匹配数据，请至参数管理中添加',
                            red: 
                  _ctx.addDeparturePortBookingMainBill &&
                  (_ctx.detail?.DeparturePortBooking ||
                    (!_ctx.detail?.DeparturePortBooking &&
                      (_ctx.detail?.DeparturePortDeclareCustoms ||
                        _ctx.detail?.DestinationPortClearCustoms ||
                        _ctx.detail?.DestinationPortExcludeClearCustoms)))
                ,
                            onHandleChange: _cache[12] || (_cache[12] = ($event: any) => (
                  _ctx.handleChangePort(
                    _ctx.form.Data.DeliveryPortId,
                    _ctx.detail?.DeliveryPortId
                  )
                )),
                            disabled: 
                  _ctx.form.Data?.BindThreeApiPropList?.contains('DeliveryPortId')
                
                          }, null, 8, ["modelValue", "label", "options", "remoteMethod", "red", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["class"]),
                      _createVNode(_component_el_form_item, {
                        label: "Place of Delivery/交货地点",
                        prop: "DeliveryPlaceLabel"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_input, {
                            modelValue: _ctx.form.Data.DeliveryPlaceLabel,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.Data.DeliveryPlaceLabel) = $event)),
                            "fetch-suggestions": _ctx.getDeliveryPlaces,
                            "trigger-on-focus": true,
                            clearable: "",
                            valueKey: "FullName"
                          }, null, 8, ["modelValue", "fetch-suggestions"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "承运人",
                        prop: "CarrierId"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_select, {
                            modelValue: _ctx.form.Data.CarrierId,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.Data.CarrierId) = $event)),
                            label: _ctx.form.Data.CarrierLabel,
                            "onUpdate:label": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.Data.CarrierLabel) = $event)),
                            options: _ctx.carriers,
                            remote: true,
                            remoteMethod: _ctx.getCarriers,
                            noDataText: '无匹配数据，请至参数管理中添加',
                            placeholder: '请填写关键词',
                            onVisibleChange: _cache[16] || (_cache[16] = 
                  (s) => {
                    if (s) _ctx.getCarriers();
                  }
                ),
                            red: 
                  _ctx.addDeparturePortBookingMainBill &&
                  _ctx.detail?.DeparturePortBooking &&
                  (_ctx.detail?.TransportContainerLoad ==
                    _ctx.EnumTransportContainerLoad.FCL ||
                    _ctx.detail?.TransportContainerLoad ==
                      _ctx.EnumTransportContainerLoad.Bulk ||
                    _ctx.detail?.TransportType == _ctx.EnumTransportType.Air ||
                    _ctx.detail?.TransportType == _ctx.EnumTransportType.Railway)
                
                          }, null, 8, ["modelValue", "label", "options", "remoteMethod", "red"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "合约号",
                        prop: "ContractNo"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_input, {
                            modelValue: _ctx.form.Data.ContractNo,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.Data.ContractNo) = $event)),
                            upperCase: true,
                            trimAll: true
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      (_ctx.detail?.TransportType == _ctx.EnumTransportType.Sea)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 1,
                            label: "船名",
                            prop: "ShipName",
                            class: _normalizeClass(_ctx.detail?.UseThreeApiService ? 'query' : '')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_miezz_input, {
                                modelValue: _ctx.form.Data.ShipName,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.Data.ShipName) = $event)),
                                red: 
                  _ctx.addDeparturePortBookingMainBill &&
                  _ctx.detail?.DeparturePortBooking &&
                  (_ctx.detail?.TransportContainerLoad ==
                    _ctx.EnumTransportContainerLoad.FCL ||
                    _ctx.detail?.TransportContainerLoad ==
                      _ctx.EnumTransportContainerLoad.Bulk)
                ,
                                disabled: 
                  _ctx.form.Data?.BindThreeApiPropList?.contains('ShipName')
                
                              }, null, 8, ["modelValue", "red", "disabled"])
                            ]),
                            _: 1
                          }, 8, ["class"]))
                        : _createCommentVNode("", true),
                      (_ctx.detail?.TransportType == _ctx.EnumTransportType.Sea)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 2,
                            label: "航次",
                            prop: "VoyageNumber",
                            class: _normalizeClass(_ctx.detail?.UseThreeApiService ? 'query' : '')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_miezz_input, {
                                modelValue: _ctx.form.Data.VoyageNumber,
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.Data.VoyageNumber) = $event)),
                                red: 
                  _ctx.addDeparturePortBookingMainBill &&
                  _ctx.detail?.DeparturePortBooking &&
                  (_ctx.detail?.TransportContainerLoad ==
                    _ctx.EnumTransportContainerLoad.FCL ||
                    _ctx.detail?.TransportContainerLoad ==
                      _ctx.EnumTransportContainerLoad.Bulk)
                ,
                                disabled: 
                  _ctx.form.Data?.BindThreeApiPropList?.contains('VoyageNumber')
                
                              }, null, 8, ["modelValue", "red", "disabled"])
                            ]),
                            _: 1
                          }, 8, ["class"]))
                        : _createCommentVNode("", true),
                      (_ctx.detail?.TransportType == _ctx.EnumTransportType.Air)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 3,
                            label: "航班",
                            prop: "Flight",
                            class: _normalizeClass(_ctx.detail?.UseThreeApiService ? 'query' : '')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_miezz_input, {
                                modelValue: _ctx.form.Data.Flight,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.Data.Flight) = $event)),
                                disabled: _ctx.form.Data?.BindThreeApiPropList?.contains('Flight')
                              }, null, 8, ["modelValue", "disabled"])
                            ]),
                            _: 1
                          }, 8, ["class"]))
                        : _createCommentVNode("", true),
                      (_ctx.detail?.TransportType == _ctx.EnumTransportType.Railway)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 4,
                            label: "班次",
                            prop: "RailwayNumber"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_miezz_input, {
                                modelValue: _ctx.form.Data.RailwayNumber,
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.Data.RailwayNumber) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_form_item, {
                        label: "装货港ETD",
                        prop: "EstimatedDepartureDate",
                        class: _normalizeClass(_ctx.detail?.UseThreeApiService ? 'query' : '')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.form.Data.EstimatedDepartureDate,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.Data.EstimatedDepartureDate) = $event)),
                            type: "datetime",
                            format: "YYYY/MM/DD HH:mm",
                            "value-format": "YYYY/MM/DD HH:mm",
                            class: _normalizeClass(`form-item-date${
                  _ctx.addDeparturePortBookingMainBill &&
                  (_ctx.detail?.DeparturePortBooking ||
                    (!_ctx.detail?.DeparturePortBooking &&
                      (_ctx.detail?.DeparturePortDeclareCustoms ||
                        _ctx.detail?.DeparturePortContainerOrWarehouse)))
                    ? ' red'
                    : ''
                }`),
                            onChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.handleCheckBusinessCycle('EstimatedDepartureDate'))),
                            disabled: 
                  _ctx.form.Data?.BindThreeApiPropList?.contains(
                    'EstimatedDepartureDate'
                  )
                
                          }, null, 8, ["modelValue", "class", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["class"]),
                      _createVNode(_component_el_form_item, {
                        label: "装货港ATD",
                        prop: "ActualDepartureDate",
                        class: _normalizeClass(_ctx.detail?.UseThreeApiService ? 'query' : '')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.form.Data.ActualDepartureDate,
                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.Data.ActualDepartureDate) = $event)),
                            type: "datetime",
                            format: "YYYY/MM/DD HH:mm",
                            "value-format": "YYYY/MM/DD HH:mm",
                            class: _normalizeClass(`form-item-date${
                  _ctx.addDeparturePortBookingMainBillAtd ? ' red' : ''
                }`),
                            onChange: _cache[25] || (_cache[25] = ($event: any) => (_ctx.handleCheckBusinessCycle('ActualDepartureDate'))),
                            disabled: 
                  _ctx.form.Data?.BindThreeApiPropList?.contains(
                    'ActualDepartureDate'
                  )
                
                          }, null, 8, ["modelValue", "class", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["class"]),
                      _createVNode(_component_el_form_item, {
                        label: "目的港ETA",
                        prop: "EstimatedArrivalDate",
                        class: _normalizeClass(_ctx.detail?.UseThreeApiService ? 'query' : '')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.form.Data.EstimatedArrivalDate,
                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.Data.EstimatedArrivalDate) = $event)),
                            type: "datetime",
                            format: "YYYY/MM/DD HH:mm",
                            "value-format": "YYYY/MM/DD HH:mm",
                            class: _normalizeClass(`form-item-date${
                  _ctx.addDeparturePortBookingMainBill &&
                  (_ctx.detail?.DeparturePortBooking ||
                    (!_ctx.detail?.DeparturePortBooking &&
                      (_ctx.detail?.DestinationPortClearCustoms ||
                        _ctx.detail?.DestinationPortExcludeClearCustoms)))
                    ? ' red'
                    : ''
                }`),
                            onChange: _cache[27] || (_cache[27] = ($event: any) => (_ctx.handleCheckBusinessCycle('EstimatedArrivalDate'))),
                            disabled: 
                  _ctx.form.Data?.BindThreeApiPropList?.contains(
                    'EstimatedArrivalDate'
                  )
                
                          }, null, 8, ["modelValue", "class", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["class"]),
                      _createVNode(_component_el_form_item, {
                        label: "目的港ATA",
                        prop: "ActualArrivalDate",
                        class: _normalizeClass(_ctx.detail?.UseThreeApiService ? 'query' : '')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.form.Data.ActualArrivalDate,
                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.form.Data.ActualArrivalDate) = $event)),
                            type: "datetime",
                            format: "YYYY/MM/DD HH:mm",
                            "value-format": "YYYY/MM/DD HH:mm",
                            class: _normalizeClass(`form-item-date${
                  _ctx.addDeparturePortBookingMainBillAta ? ' red' : ''
                }`),
                            onChange: _cache[29] || (_cache[29] = ($event: any) => (_ctx.handleCheckBusinessCycle('ActualArrivalDate'))),
                            disabled: 
                  _ctx.form.Data?.BindThreeApiPropList?.contains('ActualArrivalDate')
                
                          }, null, 8, ["modelValue", "class", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["class"]),
                      _createVNode(_component_el_form_item, {
                        label: "舱单截止时间",
                        prop: "ManifestEndDate"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.form.Data.ManifestEndDate,
                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.form.Data.ManifestEndDate) = $event)),
                            type: "datetime",
                            format: "YYYY/MM/DD HH:mm",
                            "value-format": "YYYY/MM/DD HH:mm",
                            class: _normalizeClass(`form-item-date${
                  _ctx.addDeparturePortBookingMainBill &&
                  ((_ctx.detail?.DeparturePortBooking &&
                    (_ctx.detail?.TransportContainerLoad ==
                      _ctx.EnumTransportContainerLoad.FCL ||
                      _ctx.detail?.TransportContainerLoad ==
                        _ctx.EnumTransportContainerLoad.Bulk)) ||
                    (!_ctx.detail?.DeparturePortBooking &&
                      _ctx.detail?.DeparturePortContainerOrWarehouse))
                    ? ' red'
                    : ''
                }`),
                            disabled: 
                  _ctx.form.Data?.BindThreeApiPropList?.contains('ManifestEndDate')
                
                          }, null, 8, ["modelValue", "class", "disabled"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "截关时间",
                        prop: "CustomsEndDate"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.form.Data.CustomsEndDate,
                            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.form.Data.CustomsEndDate) = $event)),
                            type: "datetime",
                            format: "YYYY/MM/DD HH:mm",
                            "value-format": "YYYY/MM/DD HH:mm",
                            class: _normalizeClass(`form-item-date${
                  _ctx.addDeparturePortBookingMainBill &&
                  (_ctx.detail?.DeparturePortBooking ||
                    (!_ctx.detail?.DeparturePortBooking &&
                      _ctx.detail?.DeparturePortDeclareCustoms))
                    ? ' red'
                    : ''
                }`),
                            disabled: 
                  _ctx.form.Data?.BindThreeApiPropList?.contains('CustomsEndDate')
                
                          }, null, 8, ["modelValue", "class", "disabled"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "开港时间",
                        prop: "OpenPortDate"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.form.Data.OpenPortDate,
                            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.form.Data.OpenPortDate) = $event)),
                            type: "datetime",
                            format: "YYYY/MM/DD HH:mm",
                            "value-format": "YYYY/MM/DD HH:mm",
                            class: _normalizeClass(`form-item-date${
                  _ctx.addDeparturePortBookingMainBill &&
                  ((_ctx.detail?.DeparturePortBooking &&
                    (_ctx.detail?.TransportContainerLoad ==
                      _ctx.EnumTransportContainerLoad.FCL ||
                      _ctx.detail?.TransportContainerLoad ==
                        _ctx.EnumTransportContainerLoad.Bulk)) ||
                    (!_ctx.detail?.DeparturePortBooking &&
                      _ctx.detail?.DeparturePortContainerOrWarehouse))
                    ? ' red'
                    : ''
                }`),
                            disabled: 
                  _ctx.form.Data?.BindThreeApiPropList?.contains('OpenPortDate')
                
                          }, null, 8, ["modelValue", "class", "disabled"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "截港时间",
                        prop: "PortEndDate"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.form.Data.PortEndDate,
                            "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.form.Data.PortEndDate) = $event)),
                            type: "datetime",
                            format: "YYYY/MM/DD HH:mm",
                            "value-format": "YYYY/MM/DD HH:mm",
                            class: _normalizeClass(`form-item-date${
                  _ctx.addDeparturePortBookingMainBill &&
                  ((_ctx.detail?.DeparturePortBooking &&
                    (_ctx.detail?.TransportContainerLoad ==
                      _ctx.EnumTransportContainerLoad.FCL ||
                      _ctx.detail?.TransportContainerLoad ==
                        _ctx.EnumTransportContainerLoad.Bulk)) ||
                    (!_ctx.detail?.DeparturePortBooking &&
                      _ctx.detail?.DeparturePortContainerOrWarehouse))
                    ? ' red'
                    : ''
                }`),
                            disabled: 
                  _ctx.form.Data?.BindThreeApiPropList?.contains('PortEndDate')
                
                          }, null, 8, ["modelValue", "class", "disabled"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "挂靠码头",
                        prop: "Dock",
                        class: _normalizeClass(_ctx.detail?.UseThreeApiService ? 'query' : '')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_input, {
                            modelValue: _ctx.form.Data.Dock,
                            "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.form.Data.Dock) = $event)),
                            "fetch-suggestions": _ctx.getDeliveryPlaces,
                            "trigger-on-focus": true,
                            clearable: "",
                            valueKey: "FullName",
                            disabled: _ctx.form.Data?.BindThreeApiPropList?.contains('Dock')
                          }, null, 8, ["modelValue", "fetch-suggestions", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["class"]),
                      _createVNode(_component_el_form_item, {
                        label: "运费支付方式",
                        prop: "TransportPaymentType"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_select, {
                            modelValue: _ctx.form.Data.TransportPaymentType,
                            "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.form.Data.TransportPaymentType) = $event)),
                            options: _ctx.EnumTransportPaymentTypeOption,
                            red: 
                  _ctx.addDeparturePortBookingMainBill &&
                  _ctx.detail?.DeparturePortBooking
                
                          }, null, 8, ["modelValue", "options", "red"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "运输类型",
                        prop: "GoodsTransportType"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_select, {
                            modelValue: _ctx.form.Data.GoodsTransportType,
                            "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.form.Data.GoodsTransportType) = $event)),
                            options: _ctx.EnumGoodsTransportTypeOption
                          }, null, 8, ["modelValue", "options"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["form", "red"]),
                  _createVNode(_component_order_form_products_summary, {
                    form: _ctx.form,
                    "onUpdate:form": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.form) = $event)),
                    reds: 
            _ctx.addDeparturePortBookingMainBill && _ctx.detail?.DeparturePortBooking
              ? [
                  'MarksNotes',
                  'PackagesNumber',
                  'PackagesKind',
                  'GoodsDescription',
                  'GrossWeight',
                  'Volume',
                ]
              : []
          
                  }, null, 8, ["form", "reds"]),
                  (
            _ctx.detail?.TransportContainerLoad == _ctx.EnumTransportContainerLoad.FCL
          )
                    ? (_openBlock(), _createBlock(_component_order_form_container, {
                        key: 0,
                        form: _ctx.form,
                        "onUpdate:form": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.form) = $event)),
                        disabledAdd: _ctx.detail?.StowageOrder,
                        disabledQuantity: _ctx.detail?.StowageOrder,
                        red: 
            _ctx.addDeparturePortBookingMainBill &&
            _ctx.detail?.DeparturePortBooking &&
            _ctx.detail?.TransportContainerLoad == _ctx.EnumTransportContainerLoad.FCL
          ,
                        showSealNumbers: 
            _ctx.detail?.TransportContainerLoad == _ctx.EnumTransportContainerLoad.FCL
          ,
                        departurePortContainer: _ctx.detail?.OpenDeparturePortContainer,
                        orderId: _ctx.detail.OrderId
                      }, null, 8, ["form", "disabledAdd", "disabledQuantity", "red", "showSealNumbers", "departurePortContainer", "orderId"]))
                    : _createCommentVNode("", true),
                  (
            _ctx.detail?.TransportContainerLoad == _ctx.EnumTransportContainerLoad.LCL
          )
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                        _createElementVNode("td", _hoisted_6, [
                          _hoisted_7,
                          _createElementVNode("div", null, [
                            _createVNode(_component_el_form_item, {
                              prop: "ContainerNo",
                              "label-width": "0px"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_miezz_input, {
                                  modelValue: _ctx.form.Data.ContainerNo,
                                  "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.form.Data.ContainerNo) = $event)),
                                  pattern: "[0-9a-z]",
                                  upperCase: true,
                                  trimAll: true
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_order_form_lading_bill, {
                    form: _ctx.form,
                    "onUpdate:form": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.form) = $event)),
                    reds: 
            _ctx.addDeparturePortBookingMainBill && _ctx.detail?.DeparturePortBooking
              ? ['LadingBillType']
              : []
          ,
                    requireds: _ctx.detail?.DeparturePortBooking ? ['LadingBillType'] : []
                  }, null, 8, ["form", "reds", "requireds"])
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("div", null, [
                      _createVNode(_component_miezz_upload, {
                        modelValue: _ctx.form.Data.Files,
                        "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.form.Data.Files) = $event)),
                        path: "order/main-bill",
                        prop: "File",
                        maxSize: 2 * 1024 * 1024
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["bottom-buttons", "onHandleFooterButtonClick"])), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalBusinessCard,
      "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.modalBusinessCard) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_company_business_card_form, {
          modelValue: _ctx.modalBusinessCard,
          "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.modalBusinessCard) = $event)),
          id: _ctx.businessCardId,
          companyId: 
        _ctx.form.Data.HasPartBill
          ? _ctx.logier?.ServiceProviderCompanyId
          : _ctx.detail?.ClientCompanyId
      ,
          parentId: _ctx.businessCardParentId,
          area: _ctx.businessCardArea,
          type: _ctx.businessCardType,
          content: _ctx.businessCardContent,
          onHandleSubmit: _ctx.handleSubmitBusinessCard
        }, null, 8, ["modelValue", "id", "companyId", "parentId", "area", "type", "content", "onHandleSubmit"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}